var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"return-object":false,"items":_vm.options,"item-text":"text","item-value":"value","clearable":""},on:{"blur":_vm.emitBlur},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-select',_vm.resetProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }